import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { AppService } from "./app.service";
import { Router } from "@angular/router";

@Injectable()
export class AdminRoleGuard implements CanActivate {
  constructor(private appService: AppService, private router: Router){}
  canActivate() {
    if (this.appService.getCurrentUser().role == 'ADMIN') {
        return true;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// /build/client-cms/src/app/admin-role.guard.ts